import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useCan } from '@/shared/auth/useCan';
import type { Capability } from '@/shared/auth/capabilities';

interface CapabilityRouteProps {
  capability: Capability;
  children: ReactNode;
}

/**
 * Route guard that renders children only when the logged user holds the given
 * capability, otherwise redirects to the admin landing route. Auth/staff gating
 * is handled by the parent StaffRoute wrapping the admin area.
 */
export const CapabilityRoute = ({ capability, children }: CapabilityRouteProps) => {
  const allowed = useCan(capability);
  return allowed ? <>{children}</> : <Navigate to="/admin" replace />;
};

export default CapabilityRoute;
